var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('button',{staticClass:"toggle-btn",class:{ active: _vm.value },attrs:{"type":"button"},on:{"click":_vm.toggle}},[_c('span'),_c('span',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }